import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import Parser from "html-react-parser";
import Testimonial from "./testimonial";

function AboutHosts(props) {
  // Declare a new state variable, which we'll call "count"

  const { data } = props;
  return (
    <>
      <div style={{ paddingTop: "50px" }}>
        <h1 className="widget-title">Meet Your Host</h1>
        <Row>
          {/* <Col md={6}>
            <img
              className="center-block img-fluid"
              src={data.left_image}
              alt=""
            ></img>
          </Col> */}
          <Col md={12}>
            <img
              className="center-block img-fluid"
              src={data.center_image}
              alt=""
            ></img>
          </Col>
          {/* <Col md={6}>
            <img
              className="center-block img-fluid"
              src={data.right_image}
              alt=""
            ></img>
          </Col> */}
        </Row>
        <br />
        {data.paragraphs.map((item, i) => {
          return <p key={`about-host=${i}}`}>{Parser(item)}</p>;
        })}
     

        {/* <Testimonial /> */}
      </div>
    </>
  );
}

export default AboutHosts;
